/* 
Modulo informativo de ilusiona
 */

import React from "react";

//REDUX
//import { useSelector } from "react-redux";

//CSS
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  root: {
    // padding: "8px",
    marginTop: "50px"
    /* position: "absolute",
    bottom: "0px"  */
  },
  navigation: {
    height: "50px",
    backgroundColor: "#363636"
  },
  link: {
    color: "#FFFFFF",
    '&:hover': {
      color: "#DF7D44"
    }
  }
});

export default function Footer() {
  const classes = useStyles();

  let d = new Date();
  let year = d.getFullYear();
  const isMobile = useMediaQuery("(max-width:500px)");

  //const user = useSelector(state => state.user);

  return (
    <div>
      <React.Fragment>
        <Grid
          container
          justify="center"
          alignItems="center"
          className={classes.root}
        >
          <Grid
            item
            // xs={11}
            // spacing={1}
            container
            alignItems="center"
            className={classes.navigation}
          >
            <Grid item md={3}>
              <Typography variant="subtitle2" align="center" style={{ color: "white" }} data-lang-html="copyright" data-lang-vars={JSON.stringify({year})}>
                © {year} -{" "}
                <a
                  className={classes.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.ilusiona.com"
                  data-lang="footer_company"
                >
                  SOLERA 1900, S.L.
                </a>
              </Typography>
            </Grid>
            {isMobile ? <Grid item></Grid> : null}
            <Grid item md={2}>
              <Typography variant="subtitle2" align="center">
                <a className={classes.link} href="/privacy-policy" data-lang="footer_privacy">
                  Política de Privacidad
                </a>
              </Typography>
            </Grid>
            <Grid item md={2}>
              <Typography variant="subtitle2" align="center">
                <a className={classes.link} href="/cookies-policy" data-lang="footer_cookies">
                  Política de Cookies
                </a>
              </Typography>
            </Grid>
            <Grid item md={2}>
              <Typography variant="subtitle2" align="center">
                <a className={classes.link} href="/legal-warning" data-lang="footer_legal">
                  Aviso Legal
                </a>
              </Typography>
            </Grid>
            <Grid item md={3}>
              <Typography variant="subtitle2" align="center">
                <a className={classes.link} href="/legal-club" data-lang="footer_club">
                  Bases del Ilusiona Club
                </a>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    </div>
  );
}
